import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { GetPincodeFromMerchantId } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const FetchPincodeFromMid = createAsyncThunk('get/fetchPincodeFromMid', GetPincodeFromMerchantId);

export const FetchPincodeFromMidSlice = createSlice({
	name: 'fetchPincodeFromMid',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[FetchPincodeFromMid.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[FetchPincodeFromMid.rejected.toString()]: setAPIError,
		[FetchPincodeFromMid.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;
			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[FetchPincodeFromMidSlice.name]: ReturnType<typeof FetchPincodeFromMidSlice.reducer>;
}

export const fetchPincodeFromMidSelector = (state: IStates): any => {
	return state[FetchPincodeFromMidSlice.name] || {};
};

export const useFetchPincodeFromMid = (): any => useSelector(fetchPincodeFromMidSelector);

export const fetchPincodeFromMid =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchPincodeFromMid(params));
		return;
	};

export const resetFetchPincodeFromMid =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchPincodeFromMidSlice.actions.RESET());
		return;
	};
